import React from 'react';
import geolocationIcon from "./location-marker.svg";
import "./GeolocationIcon.scss"

const GeolocationIcon = () =>
  <img className="geolocation-icon-image" src={geolocationIcon} alt="Your location"/>
;

export default GeolocationIcon;



// WEBPACK FOOTER //
// ./src/components/lib/Icons/GeolocationIcon/GeolocationIcon.tsx